import { Component, OnInit, Output, EventEmitter, ViewChild, Sanitizer, ElementRef, ChangeDetectorRef, Inject, AfterViewInit, Renderer2 } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { request } from 'http';
import { Router, ActivatedRoute } from '@angular/router';
//import { RequestMetadata, PagedResult } from '../../../../lib/ng-crud-table';
import { MatTableDataSource, fadeInContent } from '@angular/material';
import { DataSource } from '@angular/cdk/table';
import { MatDialog, MatDialogConfig, PageEvent, MatPaginator } from '@angular/material';
import { Row } from 'lib/ng-data-table';
import { SelectItem, Keys } from 'lib/common';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { NgSwitchCase, DOCUMENT } from '@angular/common';
import { validateBasis } from '@angular/flex-layout';
import { AppComponent } from 'src/app/app.component';
import { SystemSettingConfig } from 'src/app/shared/models/SystemSettingConfig';
import { SystemSettingsService } from 'src/app/shared/services/system-settings/system-settings.service';
import { stream } from 'exceljs';
@Component({
  selector: 'app-login-config',
  templateUrl: './login-config.component.html',
  styleUrls: ['./login-config.component.scss']
})
export class LoginConfigComponent implements OnInit {

  title: string = "Login";
  staticScreen = true;
  @Output() childTitleEvent = new EventEmitter();

  baseUrl: string;
  url: string;
  showError: boolean = false;
  showErrorMsg: string = "";
  OldPin: string="";
  pin: string="";
  ConfirmPin: string="";
  versionLabel: string = "6.4.20";
  loading: boolean = false;
  isChangePassword: boolean = false;
  
  loginDetails = new SystemSettingConfig();
  constructor(private renderer: Renderer2, private el: ElementRef,private http: HttpClient, private cdr: ChangeDetectorRef, private logservice: SystemSettingsService, private dialog: MatDialog, @Inject(DOCUMENT) private _document: Document, private router: Router, private route: ActivatedRoute) {
    this.baseUrl = environment.urlAddress + '/api/';
    //alert('config');
    debugger;
    
    //// if page is called for change password
    if (this.route.snapshot.queryParamMap.get('cp') == "1") {
      this.title = "";      
      this.isChangePassword = true;

      //to close filter and webviewerconfig popup . Note it will delete  querystring if previuosly set in url 
    this.router.navigate([{ outlets: { filterPopup: null, configPopup: null } }]);

      ////check login details
      if (sessionStorage.getItem('SystemSettings') != null) {
        this.logservice = JSON.parse(sessionStorage.getItem('SystemSettings'));
      }
      else if (localStorage.getItem('SystemSettings') != null) {
        this.logservice = JSON.parse(localStorage.getItem('SystemSettings'));
      }

      if (this.logservice.UserName != null && this.logservice.UserName != "") {

        if (this.logservice.UserName.length <= 0) {
          alert("Session expired!!");
          this.router.navigateByUrl('/login');
        }
        this.loginDetails.UserName = this.logservice.UserName;//this.logservice.logDetail.split('@')[0];
        //this.loginDetails.Pin = this.logservice.logDetail.split('@')[1];
      }
      ////end checking login details


    }

  }

  ngOnInit() {

    debugger;
    if (this.isChangePassword) {
      this.renderer.addClass(this.el.nativeElement, 'custom-class');
    }

    //alert('init');
    //const forgotPasswordKey = this.routeActive.snapshot.queryParamMap.get('fkey');
    ////to check if request is for reset password from email link clicked
    const forgotPasswordKey = this.route.snapshot.queryParamMap.get('fkey');
       

    if (forgotPasswordKey != null) {
      this.CheckVaildUserRequest(forgotPasswordKey);
    }

    this.parentEvent();

    ////below commented temporarily
    //if (this.logservice.logDetail != null) {

    //  if (this.logservice.logDetail.length <= 0) {
    //    alert("Session expired!!");
    //    this.router.navigateByUrl('/login');
    //  }
    //  this.loginDetails.UserName = this.logservice.logDetail.split('@')[0];
    //  this.loginDetails.Pin = this.logservice.logDetail.split('@')[1];
    //}
    
  }

  CheckVaildUserRequest(forgotPasswordKey) {
    this.loading = true;
    this.loginDetails.ForgotPasswodKey = forgotPasswordKey;

    this.url = this.baseUrl + 'Login/CheckVaildForgotPasswordKey';
    this.LoginData_Service().subscribe((res: any) => {
      this.loading = false;
      let rows: any = res;
      if (rows == 'failed') {
        this.router.navigateByUrl('/login');
        alert('Link is not valid');
      }
      else {
        this.loginDetails.UserName = rows;
      }

    });
  }

  CheckValidation() {
    if (this.pin != this.ConfirmPin)
      return false;
    return true;
  }

  ResetPin() {
    //alert();
    this.loading = true;
    this.showError = false;
    this.showErrorMsg = "";
    if (!this.CheckValidation()) {
      this.showError = true;
      this.showErrorMsg = "Pin and RetypePin should be same."
      return;
    }

    this.loginDetails.Pin = this.pin; //assign new pin

    this.url = this.baseUrl + 'Login/ResetPassword';
    this.LoginData_Service().subscribe((res: any) => {
      this.loading = false;
      let rows: any = res;//JSON.parse(res) as any;
      if (rows != "success") {
        this.showError = true;
        this.showErrorMsg = rows;
      }
      else {
        alert("Pin changed successfully,please login with new pin");
          this.router.navigateByUrl('/login');
      }
    });
  }

  CheckChangePasswordValidation() {
    if (this.pin.trim() == "" || this.ConfirmPin.trim() == "" || this.OldPin.trim() == "") {
      this.showError = true;
      this.showErrorMsg = "all fields are mandatory required. "
      return false;
    }
    
    if (this.pin != this.ConfirmPin) {
      this.showError = true;
      this.showErrorMsg = "Pin and RetypePin should be same."
      return false;
    }


    return true;
  }
  SaveNewPin() {
    debugger;
    this.loading = true;
    this.showError = false;
    this.showErrorMsg = "";
    if (!this.CheckChangePasswordValidation()) {
      this.loading = false;
      return;
    }

    this.loginDetails.OldPin = this.OldPin;
    this.loginDetails.Pin = this.pin; //assign new pin

    this.url = this.baseUrl + 'Login/ChangePassword';
    this.LoginData_Service().subscribe((res: any) => {
      this.loading = false;
      let rows: any = res;//JSON.parse(res) as any;     
        this.showError = true;
      this.showErrorMsg = rows;

      ///redirect to login page after successfull change password
      if (rows.includes('success')) {
        setTimeout(() => {
          alert("Pin changed successfully,please login with new pin");
          this.router.navigateByUrl('/logout');
        }, 2000);

      }


    });
  }

  ReturnToLogin() {
    this.router.navigateByUrl('login');
  }

  ///////////////////////////////////////////////////////// SERVICES

  GetData_Service() {

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, options);

  }
  LoginData_Service() {

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, this.loginDetails, options);

  }

  parentEvent() {
    this.childTitleEvent.emit({ title: this.title, staticScreen: this.staticScreen });
  }

  typeOld = 'password';
  typeNew = 'password';
  typeConf = 'password';
  onEyeClick(newOrConf) {
    //console.log(this.type)
    if (newOrConf=='new') {
      if (this.typeNew === "password") {
        this.typeNew = "text";
      }
      else {
        this.typeNew = "password";
      }
    }
    else if (newOrConf == 'old') {
      if (this.typeOld === "password") {
        this.typeOld = "text";
      }
      else {
        this.typeOld = "password";
      }
    }
    else {
      if (this.typeConf === "password") {
        this.typeConf = "text";
      }
      else {
        this.typeConf = "password";
      }
    }
  }


  close() {
    this.router.navigate([{ outlets: { popupOutlet: null } }]);
  }

}
